import React from 'react'
import {
  Wrapper,
  AddOnWrapper,
  InputField,
  LeftIconWrapper,
  RightIconWrapper
} from './styles'
import toFinalFormInput from '../FormElements/toFinalFormInput'

const Input = ({ leftAddOn, rightAddOn, leftIcon, rightIcon, disabled, ...rest }) => {
  const hasIcons = {
    hasLeftIcon: !!leftIcon,
    hasRightIcon: !!rightIcon
  }
  return (
    <Wrapper {...hasIcons} disabled={disabled}>
      {
        leftAddOn && (
          <AddOnWrapper>
            {leftAddOn}
          </AddOnWrapper>
        )
      }
      <InputField {...rest} {...hasIcons} hasRightAddOn={!!rightAddOn} disabled={disabled} />
      {
        (leftIcon && !leftAddOn) && (
          <LeftIconWrapper>
            {leftIcon}
          </LeftIconWrapper>
        )
      }
      {
        (rightIcon && !rightAddOn) && (
          <RightIconWrapper>
            {rightIcon}
          </RightIconWrapper>
        )
      }
      {
        rightAddOn && (
          <AddOnWrapper>
            {rightAddOn}
          </AddOnWrapper>
        )
      }

    </Wrapper>
  )
}

export const FinalInput = toFinalFormInput(Input)

export default Input



// WEBPACK FOOTER //
// ./src/Components/Input/Input.jsx